import { useEffect, useState } from "react";
import moment from "moment";
import styled from "styled-components";
import DefaultCalendar from "react-calendar";
import { LoadingSpinner } from "@webtypen/react-components";
import { ApiHelper } from "../helpers";
import "react-calendar/dist/Calendar.css";
import { useNavigate } from "react-router-dom";

const Wrapper = styled.div`
    position: relative;

    .font-bold {
        font-weight: bold !important;
    }

    .react-calendar {
        width: 100%;
        border: none;
        font-family: "Montserrat", sans-serif;
        user-select: none;

        .react-calendar__navigation__label {
            font-family: "Montserrat", sans-serif;
            user-select: none;

            .react-calendar__navigation__label__labelText.react-calendar__navigation__label__labelText--from {
                font-weight: bold;
            }
        }

        .react-calendar__tile {
            color: #676a6c;
            font-family: "Montserrat", sans-serif;
            cursor: default !important;
            user-select: none;
            border-radius: 5px;

            &.react-calendar__month-view__days__day--weekend {
            }

            &.react-calendar__month-view__days__day--neighboringMonth {
                opacity: 0.5;
            }

            &.react-calendar__tile--now {
                opacity: 1;
                background: ${(props) => props.theme.color.primary};
                color: ${(props) => props.theme.color.light};

                &:hover {
                    background: ${(props) => props.theme.color.primary};
                    color: ${(props) => props.theme.color.light};
                }
            }

            &:hover,
            &:focus,
            &:active {
                background: transparent;
            }
        }
    }
`;

const LoadingWrapper = styled.div`
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    flex-direction: column;
    user-select: none;
    font-weight: bold;
`;

export const Calendar = ({ containerAttributes, ...rest }) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [dateinfo, setDateinfo] = useState(null);
    const [daterange, setDaterange] = useState({
        begin: moment().startOf("month").format("YYYY-MM-DD"),
        end: moment().endOf("month").format("YYYY-MM-DD"),
    });

    const onDaterangeChange = (event) => {
        const dateBegin = moment(event.activeStartDate).startOf("month").format("YYYY-MM-DD");
        const dateEnd = moment(dateBegin).endOf("month").format("YYYY-MM-DD");
        setDaterange({ begin: dateBegin, end: dateEnd });
    };

    const handleClassName = (event) => {
        if (!dateinfo || !event || !event.date) {
            return "";
        }

        const date = moment(event.date).format("YYYY-MM-DD");
        if (dateinfo[date] === "available") {
            return "text-primary font-bold";
        } else if (dateinfo[date] === "allocated") {
            return "text-danger font-bold";
        } else if (dateinfo[date] === "auth_user_allocated") {
            return "text-success font-bold";
        }
        return "";
    };

    useEffect(() => {
        const begin = moment(daterange.begin).subtract(10, "days");
        const end = moment(daterange.end).add(10, "days");

        setIsLoading(true);
        ApiHelper.request("/api/dashboard/calendar-data", {
            begin: begin.format("YYYY-MM-DD"),
            end: end.format("YYYY-MM-DD"),
        })
            .then((response) => {
                setDateinfo(response.status === "success" && response.data ? response.data : null);
                setIsLoading(false);
            })
            .catch((e) => {
                console.error(e);
                setDateinfo(null);
                setIsLoading(false);
            });
    }, [daterange]);

    return (
        <Wrapper {...containerAttributes}>
            {isLoading ? (
                <LoadingWrapper>
                    <LoadingSpinner className="mb-2" />
                    Monat wird geladen ...
                </LoadingWrapper>
            ) : null}

            <DefaultCalendar
                value={null}
                tileClassName={handleClassName}
                onActiveStartDateChange={onDaterangeChange}
                onClickDay={() => navigate("/contracts")}
                {...rest}
            />
        </Wrapper>
    );
};
